import reactDom from 'react-dom'
import App from './app'
import reducers from './reducers'
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { Router } from 'react-router-dom'
import history from './history'
import ScrollToTop from '../src/components/utils/scrollToTop'


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const reduxStore = createStore(reducers, composeEnhancers(applyMiddleware(thunk)))

reactDom.render(
    <Provider store={reduxStore}>
     <Router history={history}>
        <ScrollToTop />
        <App />
    </Router>
    </Provider>,
    document.querySelector('#afzal')
)